import { makeActionHandler } from "./_reducerUtils";

export const evaluationReducer = {
  initialState: {
    evaluationResult: {
      list: []
    },
    evaluationCriteriaGroup: {
      list: [],
      isLoaded: false
    },
    evaluationQuestion: {
      list: [],
      isLoaded: false
    },
    resumePerformance: {
      list: []
    },
    resumeCompetence: {
      list: []
    },
    evaluationResultDetails: {
      /** @type {Object} */
      details: {},
      graphData: [],
      notations: [],
      objectives: [],
      isLoading: false,
      isLoaded: false,
      isChangingYear: false,
      /** @type {number | null} */
      year: null
    },
    evaluationHistory: {
      list: [],
      isLoading: false,
      isLoaded: false
    },
    evaluationAlert: {
      list: [],
      isLoaded: false,
      assignedEmployee: ""
    },
    eligibleEvaluator: {
      list: [],
      isLoaded: false,
      isDataOutdated: false,
      isRefreshing: false
    },
    evaluationRequestOverview: {
      list: [],
      isLoaded: false,
      selected: null
    },
    evaluationByAssigned: {
      list: [],
      isLoaded: false,
      assignedEmployee: "",
      evaluationRequestList: [],
      evaluationAlertList: [],
      filter: {},
      isRefreshing: false
    },
    evaluationRequestTemplate: {
      list: [],
      isLoaded: false
    }
  },
  handlers: {
    "evaluation/SET_EVALUATION_RESULT": makeActionHandler("evaluationResult"),
    "evaluation/SET_ELIGIBLE_EVALUATOR": makeActionHandler("eligibleEvaluator"),
    "evaluation/SET_EVALUATION_CRITERIA_GROUP": makeActionHandler(
      "evaluationCriteriaGroup"
    ),
    "evaluation/SET_EVALUATION_QUESTION":
      makeActionHandler("evaluationQuestion"),

    "evaluation/SET_RESUME_PERFORMANCE": makeActionHandler("resumePerformance"),
    "evaluation/SET_RESUME_COMPETENCE": makeActionHandler("resumeCompetence"),
    "evaluation/SET_EVALUATION_RESULT_DETAILS": makeActionHandler(
      "evaluationResultDetails"
    ),
    "evaluation/SET_EVALUATION_HISTORY": makeActionHandler("evaluationHistory"),

    "evaluation/SET_EVALUATION_ALERT": makeActionHandler("evaluationAlert"),

    "evaluation/SET_EVALUATION_REQUEST_OVERVIEW": makeActionHandler(
      "evaluationRequestOverview"
    ),
    "evaluation/SET_EVALUATION_BY_ASSIGNED": makeActionHandler(
      "evaluationByAssigned"
    ),
    "evaluation/SET_EVALUATION_REQUEST_TEMPLATE": makeActionHandler(
      "evaluationRequestTemplate"
    ),

    "evaluation/RESET_ALL": () => evaluationReducer.initialState,
    "RESET_ALL": () => evaluationReducer.initialState
  }
};

export default evaluationReducer;
